// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__hYh7p","dragIcon":"Choice_dragIcon__1kefC","left":"Choice_left__2O7hd","input":"Choice_input__2nUuE"};